<template>
  <barcode-chart
    v-bind:chart-id="chartId"
    v-bind:chart-data="chartData"
    v-bind:chart-options="chartOptions"
    v-bind:plugins="chartPlugins"
    v-bind:dataset-id-key="'label'"
    v-bind:width="width"
    v-bind:height="height"
    v-bind:css-classes="'chart-barcode'"
  />
</template>

<script>
import { Bar } from 'vue-chartjs/legacy'
import {
  Chart,
  BarController,
  BarElement,
  TimeScale,
  CategoryScale,
  Legend,
  Tooltip,
} from 'chart.js'
import 'chartjs-adapter-moment'

Chart.register(
  BarController,
  BarElement,
  TimeScale,
  CategoryScale,
  Legend,
  Tooltip
)

/**
 * 帯チャートコンポーネント
 */
export default {
  name: 'AppCharBarcode',
  components: {
    'barcode-chart': Bar,
  },
  props: {
    /**
     * チャートID
     */
    chartId: {
      type: String,
      default: 'barcode-chart',
    },
    /**
     * チャート表示データ
     *
     * ```
     * {
     *   labels: ,
     *   datasets: [
     *     {
     *       label: 'dataname',
     *       data: [{sensor_at: 1654741353000, value: 328}, ...],
     *     },
     *     ...
     *   ],
     * }

     * ```
     *
     * **property**
     *
     * * `labels` {String|Array} データを一意に特定する名称(datasets.data の各レコードが Object の場合は空文字でOK)
     * * `datasets` {Array} 実データ
     */
    data: {
      type: Object,
      default: () => {},
    },
    /**
     * チャートオプション
     */
    options: {
      type: Object,
      default: () => {},
    },
    /**
     * チャートに使用するプラグイン
     */
    plugins: {
      type: Array,
      default: () => [],
    },
    /**
     * チャート幅(px)
     */
    width: {
      type: Number,
      default: 400,
    },
    /**
     * チャート高さ(px)
     */
    height: {
      type: Number,
      default: 250,
    },
  },
  data: function () {
    return {}
  },
  computed: {
    chartData: function () {
      return { ...this.data }
    },
    chartOptions: function () {
      return { ...this.options }
    },
    chartPlugins: function () {
      return [...this.plugins]
    },
  },
}
</script>

<style lang="scss" scoped>
.chart-barcode {
  width: 100%;
  height: 100%;
  position: relative;
}
</style>
